module.exports = __webpack_public_path__ + "static/flags/JP-bc3783a65c4ac6ab2498284e61a5e868.gif";